import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import qs from 'qs';

import DailyUsageList from '../components/DailyUsageList/DailyUsageList';
import subPage from '../decorators/subPage';
import { getSubDailyUsage } from '../reducers';
import { findSubDailyUsage } from '../actions/subs';

class DailyUsagePage extends Component {
  componentDidMount() {
    this.fetchDailyUsage();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.subId !== this.props.subId) {
      this.fetchDailyUsage();
    }

    if (oldProps.cycle !== this.props.cycle) {
      this.fetchDailyUsage();
    }
  }

  fetchDailyUsage() {
    const { findSubDailyUsage, subId, cycle } = this.props;
    findSubDailyUsage(subId, cycle);
  }

  render() {
    const { sub, subId, cycle, usage } = this.props;
    if (!sub) {
      return <div>Loading...</div>;
    }

    if (!usage) {
      return <div>Not Found...</div>;
    }

    return (
      <div>
        <h1>Daily Usage</h1>
        <Link to={`/subscriptions/${subId}/view`}>← Back to subscription</Link>
        <div>
          <Link
            className={cycle === 'previous' ? 'btn disabled' : 'btn'}
            to={`/subscriptions/${subId}/daily-usage?cycle=previous`}
          >
            Previous
          </Link>
          <Link
            className={cycle === 'current' ? 'btn disabled' : 'btn'}
            to={`/subscriptions/${subId}/daily-usage?cycle=current`}
          >
            Current
          </Link>
        </div>
        <DailyUsageList usage={usage} />
      </div>
    );
  }
}

const mapStateToProps = (state, { location: { search }, subId }) => {
  const { cycle = 'current' } = qs.parse(search, { ignoreQueryPrefix: true });
  return {
    usage: getSubDailyUsage(state, subId),
    cycle,
  };
};

const mapDispatchToProps = {
  findSubDailyUsage,
};

DailyUsagePage = subPage(
  connect(mapStateToProps, mapDispatchToProps)(DailyUsagePage),
);

export default DailyUsagePage;
